const pcnsocialmedia = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Social Media",
      },
      {
        type: "tabs",
        size: "9",
        style: "",
        class: "pr-4",
        children: [
          {
            title: "Social Media",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "onlineServicesTab",
                size: "12",
                style: "",
                class: "p-0",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style: "min-height: calc(100vh - 144px)",
                  class: "pl-3 pt-3",
                  form: {
                    image1: {
                      type: "image",
                      size: "0",
                      source: "facebook-icon.svg",
                    },
                    facebook_url: {
                      type: "text",
                      label: "Facebook URL",
                      placeholder: "Enter URL",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "7",
                      style: "",
                    },
                    facebook_footer: {
                      type: "toggle",
                      label: "Footer ",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    facebook_patientnews: {
                      type: "toggle",
                      label: "PCN News",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    image2: {
                      type: "image",
                      size: "0",
                      source: "twitter-icon.svg",
                    },
                    twitter_url: {
                      type: "text",
                      label: "X URL",
                      placeholder: "Enter URL",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "7",
                      style: "",
                    },
                    twitter_footer: {
                      type: "toggle",
                      label: "Footer  ",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    twitter_patientnews: {
                      type: "toggle",
                      label: "PCN News ",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    image3: {
                      type: "image",
                      size: "0",
                      source: "youtube-icon.svg",
                    },
                    youtube_url: {
                      type: "text",
                      label: "Youtube URL",
                      placeholder: "Enter URL",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "7",
                      style: "",
                    },
                    youtube_footer: {
                      type: "toggle",
                      label: "Footer   ",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    // "youtube_patientnews": {
                    //     "type": 'toggle',
                    //     "label": 'Patient News',
                    //     "placeholder": 'Select Featured',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "2",
                    //     "style": ""
                    // },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    image4: {
                      type: "image",
                      size: "0",
                      source: "instagram-icon.svg",
                    },
                    instagram_url: {
                      type: "text",
                      label: "Instagram URL",
                      placeholder: "Enter URL",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "7",
                      style: "",
                    },
                    instagram_footer: {
                      type: "toggle",
                      label: "Footer    ",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                    image5: {
                      type: "image",
                      size: "0",
                      source: "lin_icon.svg",
                    },
                    lin_url: {
                      type: "text",
                      label: "Linkedin URL",
                      placeholder: "Enter URL",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "7",
                      style: "",
                    },
                    lin_footer: {
                      type: "toggle",
                      label: "Footer",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { pcnsocialmedia };
